import axios from 'axios';
import { getAdminApiBaseUrl } from '../config/adminRuntime';

export interface NotificationDto {
  id: string;
  recipientType: string;
  recipientId: string | null;
  type: string;
  title: string;
  message: string;
  payload: string | null;
  isRead: boolean;
  createdAt: string;
}

const client = () =>
  axios.create({
    baseURL: getAdminApiBaseUrl(),
    headers: { Authorization: `Bearer ${localStorage.getItem('adminToken') || ''}` },
  });

export const notificationsApi = {
  getAdminNotifications: (limit = 50) =>
    client().get<NotificationDto[]>(`/Notifications/admin?limit=${limit}`),

  getAdminUnreadCount: () =>
    client().get<{ count: number }>('/Notifications/admin/unread-count'),

  markAllAdminRead: () =>
    client().put('/Notifications/admin/read-all'),

  markAsRead: (id: string) =>
    client().put(`/Notifications/${id}/read`),
};
